export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";